{
  "name": "new-biblioteca-digital",
  "version": "1.1.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4201",
    "build": "ng build",
    "build-dev": "ng build --configuration development",
    "build-qa": "ng build --configuration qa",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint --fix",
    "stylelint": "stylelint \"**/*.scss\" --fix",
    "format": "prettier --write \"src/*.{ts,html,css,scss}\"",
    "format:check": "prettier --check \"src/*.{ts,html,css,scss}\"",
    "prestart": "npm run lint && npm run format && npm run stylelint",
    "prebuild": "npm run lint && npm run format && npm run stylelint"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/eslint-plugin": "^19.1.0",
    "@angular/animations": "^18.0.0",
    "@angular/cdk": "^18.1.0",
    "@angular/cli": "^18.2.4",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/forms": "^18.0.0",
    "@angular/material": "^18.1.0",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@types/clevertap-web-sdk": "^1.1.11",
    "clevertap-web-sdk": "^1.9.6",
    "flag-icons": "^7.2.3",
    "moment": "^2.30.1",
    "rxjs": "~7.8.0",
    "swiper": "^11.1.5",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.4",
    "@angular-eslint/eslint-plugin-template": "^19.1.0",
    "@angular-eslint/template-parser": "^19.1.0",
    "@angular/compiler-cli": "^18.0.0",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "^8.24.1",
    "@typescript-eslint/parser": "^8.24.1",
    "angular-eslint": "19.1.0",
    "cypress": "^13.13.2",
    "eslint": "^9.20.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-prettier": "^5.2.3",
    "globals": "^15.15.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.4.3",
    "prettier": "^3.5.1",
    "stylelint": "^16.14.1",
    "stylelint-config-standard": "^37.0.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "stylelint-config-tailwindcss": "^1.0.0",
    "tailwindcss": "^3.4.4",
    "typescript": "~5.4.2",
    "typescript-eslint": "8.23.0"
  }
}
